export default "<router-outlet></router-outlet>\n<app-copilot *ngIf=\"isLogged\"></app-copilot>";